// Utility function to normalize image URLs
// Replaces localhost URLs with current backend URL

import { API_BASE_URL } from '../config/apiConfig';

export const normalizeImageUrl = (imageUrl: string | undefined | null): string => {
  if (!imageUrl) return '';
  
  // If it's Base64, return as is
  if (imageUrl.startsWith('data:')) {
    return imageUrl;
  }
  
  // If it's a full URL but contains localhost, replace with current backend URL
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    // Check if it's a localhost URL (localhost, 127.0.0.1, or any localhost with port)
    if (imageUrl.includes('localhost') || imageUrl.includes('127.0.0.1')) {
      // Extract the path part and use current backend URL
      try {
        const url = new URL(imageUrl);
        const path = url.pathname;
        // Ensure API_BASE_URL doesn't have trailing slash and path starts with /
        const baseUrl = API_BASE_URL.replace(/\/$/, '');
        const normalizedPath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${normalizedPath}`;
      } catch (e) {
        // If URL parsing fails, try to extract path manually
        const pathMatch = imageUrl.match(/\/uploads\/.*/);
        if (pathMatch) {
          const baseUrl = API_BASE_URL.replace(/\/$/, '');
          return `${baseUrl}${pathMatch[0]}`;
        }
        // If no path found, return empty
        return '';
      }
    }
    // If it's a valid external URL (not localhost), return as is
    return imageUrl;
  }
  
  // If it's just a number (LOB OID), it's invalid - return empty
  if (/^\d+$/.test(imageUrl.trim())) {
    console.warn('Image is stored as LOB OID, not a valid image:', imageUrl);
    return '';
  }
  
  // Ensure API_BASE_URL doesn't have trailing slash
  const baseUrl = API_BASE_URL.replace(/\/$/, '');
  
  // If it's a relative path starting with /uploads, prepend the backend URL
  if (imageUrl.startsWith('/uploads/')) {
    return `${baseUrl}${imageUrl}`;
  }
  
  // If it's just a filename or path without leading slash, construct the full path
  if (imageUrl.includes('uploads/')) {
    const normalizedPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
    return `${baseUrl}${normalizedPath}`;
  }
  
  // Default: return as is (might be a relative path or filename)
  const normalizedPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
  return `${baseUrl}${normalizedPath}`;
};

